export const API_URL =
  process.env.REACT_APP_API_LOC === "local"
    ? "http://localhost:3031/"
    : "https://ahp-backoffice.openkit.app/api/";
